import { createAction } from 'utils/redux'

export const fetchServiceData = createAction('FETCH_SERVICE_DATA')
export const fetchServiceDataSuccess = createAction(
  'FETCH_SERVICE_DATA_SUCCESS'
)
export const fetchServiceDataFailed = createAction('FETCH_SERVICE_DATA_FAILED')
export const fetchServiceDataPending = createAction(
  'FETCH_SERVICE_DATA_PENDING'
)

export const exportServiceData = createAction('EXPORT_SERVICE_DATA')
export const exportServiceDataSuccess = createAction(
  'EXPORT_SERVICE_DATA_SUCCESS'
)
export const exportServiceDataFailed = createAction(
  'EXPORT_SERVICE_DATA_FAILED'
)
